export const environment = {
  production: false,
  url: 'https://dev.admin.kisportas.hu/',
  env: 'dev',
  appServer: 'https://dev.app.kisportas.hu/',
};
